import { AfterViewChecked, Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { LayoutComponent } from './layout.component';
import { MyApplication } from './layout.model';
import { MyApplicationsService } from './services/my-applications.service';

@Component({
  selector: 'app-topbar',
  template: `
  <div class="topbar clearfix">
    <div class="topbar-left">
      <ng-container *ngTemplateOutlet="logo"></ng-container>
    </div>
    <div class="topbar-right">
      <a href="#" id="menu-button" (click)="toggleMenu()" [class.menu-button-rotate]="slimMenu">
        <i class="fa fa-angle-left"></i>
      </a>
      <ul class="topbar-items fadeInDown">
        <li app-profile-menu
          *ngIf="app.profileMode==='top'||app.isHorizontal()"
          #profile
          [ngClass]="{'active-top-menu': activeTopbarItem === profile}"
          [userFullname]="userFullname"
          [userLogin]="userLogin"
          (iconClick)="onTopbarItemClick($event, profile)"
          (logout)="onLogout()"
          class="profile-item"
        >
          <ng-container *ngTemplateOutlet="profileMenuTemplate"></ng-container>
        </li>
        <li *ngIf="applications && applications.length > 0" app-applications-menu
          #applicationsItem
          [ngClass]="{'active-top-menu': activeTopbarItem === applicationsItem}"
          [applications]="applications"
          (iconClick)="onTopbarItemClick($event, applicationsItem)"
        ></li>
      </ul>
      <ng-container *ngTemplateOutlet="items"></ng-container>
    </div>
  </div>
  ` 
})

export class TopbarComponent implements OnInit, AfterViewChecked, OnDestroy {
  @Input() userFullname: string | undefined;
  @Input() userLogin: string | undefined;
  @Input() slimMenu = false;
  @Input() profileMenuTemplate!: TemplateRef<unknown>;
  @Input() items!: TemplateRef<unknown>;
  @Input() logo!: TemplateRef<unknown>;
  @Output() visibilityChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public applications: MyApplication[] = [];
  public topbarItemClick = false;
  public activeTopbarItem: unknown;

  private documentClickListener: (() => void) | null = null;

  constructor(
    public app: LayoutComponent,
    private myApplicationsService: MyApplicationsService,
    private router: Router,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.myApplicationsService.get()
      .pipe(
        map(apps => apps.filter(app => app.url !== ''))
      )
    //.subscribe(a => this.applications = a);
  }

  ngAfterViewChecked(): void {
    this.bindDocumentClickListener();
  }

  ngOnDestroy(): void {
    this.unbindDocumentClickListener();
  }

  bindDocumentClickListener(): void {
    if (!this.documentClickListener) {
      this.documentClickListener = this.renderer.listen('document', 'click', () => {
        if (this.topbarItemClick) {
          this.hideMenus();
        }
      });
    }
  }

  unbindDocumentClickListener(): void {
    if (this.documentClickListener) {
      this.documentClickListener();
      this.documentClickListener = null;
    }
  }

  hideMenus(): void {
    this.topbarItemClick = false;
    this.activeTopbarItem = null;
    this.unbindDocumentClickListener();
  }

  onTopbarItemClick(event: MouseEvent, item: unknown): void {
    this.topbarItemClick = true;

    if (this.activeTopbarItem === item) {
      this.activeTopbarItem = null;
    } else {
      this.activeTopbarItem = item;
    }

    event.preventDefault();
    event.stopPropagation();
  }

  onLogout(): void {
    void this.router.navigate(['/logout']);
  }

  toggleMenu(): boolean {
    this.slimMenu = !this.slimMenu;
    this.visibilityChange.emit(this.slimMenu);
    return false;
  }
}
